import React, { useContext, useState } from "react";
import { S3_ENDPOINT, formatMonto, getValue } from "../../utils";
import { ModalContext } from "../../context/ModalContext";
import InscriptionWeb from "../modal/web/InscriptionWeb";
import ProductContent from "./ProductContent";
import parse from "html-react-parser";
import { Link } from "@reach/router";
import moment from "moment";
import { getLocationName } from "../../utils/location";
import { getPrice, hasSalePrice } from "../../utils/products";

const ProductCard = ({
  mode,
  course,
  product,
  location,
  course_accesses,
  completed_courses,
  isWideLayout,
}) => {
  const { modalComponent } = useContext(ModalContext);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleContent = () => {
    modalComponent(
      "Temario",
      <ProductContent product_id={product.product_id} />
    );
  };

  const getSrc = () => {
    return product.file && product.file !== null
      ? `${product.file.name}.${product.file.type}`
      : "";
  };

  const getAccess = () => {
    if (Array.isArray(course_accesses)) {
      let currentAccesses = course_accesses.map(({ course_id }) => course_id);
      let { course_products } = product;
      let hasAccess = false;
      course_products.forEach(({ course_id }) => {
        if (currentAccesses.includes(course_id)) {
          hasAccess = true;
        }
      });
      return hasAccess;
    }
  };

  const getPrecondition = () => {
    if (product.product_id !== 6) return true;
    if (Array.isArray(completed_courses)) {
      const currentCourse = completed_courses.find(
        ({ course_id }) => course_id === 1
      );
      return currentCourse !== undefined;
    }
  };

  const src = getSrc();

  const renderModal = () => {
    if (showModal) {
      return (
        <InscriptionWeb
          mode={mode}
          show={showModal}
          location={location}
          handleClose={handleClose}
          product_id={product.product_id}
        />
      );
    }
  };

  const renderDates = () => {
    let { start_date, end_date } = product;
    if (start_date !== null && end_date !== null) {
      const diff = moment(end_date)
        .utc()
        .diff(moment(start_date).utc(), "days");
      if (diff > 1) {
        return (
          <p className="mb-4 ps-2">
            <span className="badge badge-pill" style={{ backgroundColor: "#55283C", color: "#E4E9F4" }}>
              <i className="fa fa-calendar me-2"></i>
              {new Array(diff + 1).fill(1).map((one, index) => (
                <span>
                  {moment(start_date).utc().add(index, "days").format("D")}
                  {index === diff - 1 ? " y " : index < diff ? ", " : ""}
                </span>
              ))}{" "}
              de {moment(end_date).utc().format("MMM YYYY")}
            </span>
          </p>
        );
      }
      return (
        <p className="mb-4 ps-2">
          <span className="badge badge-pill bg-danger">
            <i className="fa fa-calendar me-2"></i>
            {moment(start_date).utc().format("DD MMM YYYY")} -{" "}
            {moment(end_date).utc().format("DD MMM YYYY")}
          </span>
        </p>
      );
    }
  };

  const renderCapacity = () => {
    const { capacity } = product;
    if (capacity > 0 && capacity !== null && product.mode === "live") {
      const current_capacity = capacity - product.purchases.length;
      if (current_capacity <= 0) {
        return (
          <p>
            <span className="badge badge-pill bg-danger">Sold Out</span>
          </p>
        );
      }
      return (
        <p className="mb-4 text-secondary small">
          Cupo Limitado: {current_capacity} espacios restantes
        </p>
      );
    }
  };

  const renderPrice = () => {
    const product_price = getPrice(product);
    const onSale = hasSalePrice(product);
    const access = getAccess();
    if (product_price && !access) {
      return (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "20px 0",
            borderRadius: "0px 0px 0px 25px",
          }}
          className="d-none bold bg-dark d-lg-block text-center text-white"
        >
          {onSale && (
            <del className="h5 text-danger d-block">
              ${formatMonto(product.price)} MXN
            </del>
          )}
          <span className="h3 bold">${formatMonto(product_price)} MXN</span>
          {product?.price_usd && product?.price_usd !== null && (
            <p className="h5 mb-0">
              ${formatMonto(getPrice(product, "usd"))} USD
            </p>
          )}
        </div>
      );
    }
  };

  const btnW = "w-100 w-md-auto";

  const renderButton = () => {
    const access = getAccess();
    if (access) {
      const preconditionMet = getPrecondition();
      if (!preconditionMet) {
        return (
          <button
            className={`btn btn-dark ${btnW}`}
            onClick={handleShow}
            disabled={true}
          >
            Completa el curso anterior
          </button>
        );
      }
      if (moment(access.expiration_date).isBefore(moment())) {
        return (
          <button onClick={handleShow} className={`btn btn-dark ${btnW}`}>
            Acceso expirado
          </button>
        );
      }
      if (access.start_date !== null) {
        if (moment(access.start_date).utc().isAfter(moment().utc())) {
          return (
            <button className={`btn btn-dark ${btnW}`} disabled={true}>
              Acceso a partir de{" "}
              {moment(access.start_date).utc().format("DD MMM YYYY")}
            </button>
          );
        }
      }
      return (
        <Link
          to={`/mytbm/course/${product.product_id}`}
          className={`btn btn-primary text-white ${btnW}`}
        >
          Continuar
        </Link>
      );
    }
    if (window.location.pathname.includes("mytbm") && !product.upcoming) {
      return (
        <Link to="/courses" className={`btn btn-primary ${btnW}`}>
          Inscríbete
        </Link>
      );
    }

    const upcoming = getValue(course, "upcoming", true);

    if (product.capacity !== null) {
      const current_capacity = product?.capacity - product?.purchases?.length;

      if (current_capacity <= 0) {
        return (
          <button
            disabled
            className={`btn btn-primary ${btnW}`}
          >
            Sold out
          </button>
        );
      }
    }

    return (
      <button
        className={`btn btn-primary ${btnW}`}
        disabled={upcoming}
        onClick={handleShow}
      >
        {upcoming ? "Coming soon" : "Inscríbete"}
      </button>
    );
  };

  const renderLocation = () => {
    let { location } = product;
    if (location !== null) {
      location = getLocationName(location);
      return (
        <span className="ms-3 large text-secondary">
          <i className="fa text-danger fa-map-pin me-2"></i>
          <span className="badge badge-pill text-dark" style={{ backgroundColor: "#FFB66B" }}>{location}</span>
        </span>
      );
    }
  };

  const renderDescription = () => {
    if (!window.location.pathname.includes("mytbm")) {
      return (
        <div>
          {parse(product.short_description)}
          {parse(product.description)}
        </div>
      );
    }
  };

  const renderPrecondition = () => {
    if (product.product_id === 42) {
      return (
        <div>
          <span className="badge badge-pill bg-danger">Requisito:</span>
          <span className="d-block small bold">Completar Primero</span>
          <span className="d-block small bold">Sculpt and Burn</span>
          <span className="d-block mb-3" style={{ fontSize: 12 }}>
            Una vez finalizada la certificación de Sculpt and Burn, puedes
            continuar con Barre (no es necesario esperar tus resultados de SNB).
          </span>
        </div>
      );
    }
    if (product.product_id === 6) {
      return (
        <div>
          <span className="badge badge-pill bg-danger">Requisito:</span>
          <span className="d-block small bold">Completar Primero</span>
          <span className="d-block small bold">Sculpt and Burn</span>
          <span className="d-block mb-3" style={{ fontSize: 12 }}>
            Una vez finalizada la certificación de Sculpt and Burn, puedes
            continuar con Barre (no es necesario esperar tus resultados de SNB).
          </span>
        </div>
      );
    }
    if (product.product_id === 37) {
      return (
        <div>
          <span className="badge badge-pill bg-danger">Requisito:</span>
          <span className="d-block small bold">Completar Primero</span>
          <span className="d-block small bold">Sculpt and Burn y Barre</span>
          <span className="d-block mb-3" style={{ fontSize: 12 }}>
            Una vez finalizada la certificación de Sculpt and Burn y Barre, puedes
            continuar con Block Burn Pilates (no es necesario esperar tus
            resultados de las anteriores).
          </span>
        </div>
      );
    }
  };

  const mobilePriceStripe = () => (
    <div className="d-lg-none bg-dark text-white text-center w-100 py-3 px-3 mt-auto flex-shrink-0">
      <span className="small fw-normal d-block">desde</span>
      <span className="h3 bold mb-0 d-block">
        $ {formatMonto(getPrice(product))} MXN
      </span>
    </div>
  );

  return (
    <div
      className="product-card-layout bg-white d-flex align-items-stretch home-course flex-column flex-lg-row h-100 w-100 border-0 shadow"
      style={{
        border: "1px solid #27272b",
        cursor: "pointer",
        borderRadius: "25px",
        maxWidth: isWideLayout ? "min(1600px, 100%)" : "1200px",
        marginInline: "auto",
      }}
    >
      <div
        className="image-section d-none d-lg-flex flex-shrink-0"
        style={{ position: "relative", width: "50%", height: "100%" }}
      >
        <div
          style={{
            backgroundImage: `url(${S3_ENDPOINT}/${src})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            borderRadius: "25px 0px 0px 25px",
            height: "100%",
          }}
          className="col-12"
        ></div>
        {renderPrice()}
      </div>

      <div
        className="product-card-text-section d-flex flex-column flex-grow-1 align-items-stretch bg-white mb-0 px-0 overflow-hidden"
        style={{ minWidth: 0 }}
      >
        <div className="d-flex flex-column flex-grow-1 min-h-0 w-100" style={{ minWidth: 0 }}>
          <img
            alt={product?.name ?? "product"}
            src={`${S3_ENDPOINT}/${src}`}
            className="d-block d-lg-none w-100 flex-shrink-0"
            style={{
              objectFit: "cover",
              maxHeight: "min(420px, 52vh)",
            }}
          />
          <div className="d-flex flex-column flex-grow-1 min-h-0 px-3 ps-lg-4 pe-lg-3 pb-3 pt-3" style={{ minWidth: 0 }}>
            <div className="d-flex flex-column flex-grow-1 gap-3 min-h-0" style={{ minWidth: 0 }}>
              <div className="w-100 text-start flex-grow-1" style={{ minWidth: 0, overflowWrap: "break-word" }}>
                {mode === "live" ? (
                  <img
                    src="https://thebodymethod.s3.us-west-1.amazonaws.com/tbmcert-logo-negro.png"
                    alt="logo"
                    style={{ width: "400px", maxWidth: "100%", marginBottom: "6px" }}
                  />
                ) : (
                  <h3 className="h2 francois">{product.name}</h3>
                )}
                <span className="d-block mb-3">
                  <span
                    className={`badge badge-pill text-capitalize bg-${mode === "on-demand" ? "primary text-white" : "accent text-dark"
                      }`}
                  >
                    {mode === "live" ? "En vivo" : mode}
                  </span>
                  {renderLocation()}
                </span>
                {renderDescription()}
                {renderPrecondition()}
                <div className="d-flex justify-content-start">{renderDates()}</div>
                {renderCapacity()}
              </div>
              <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-stretch gap-2 w-100">
                <button
                  onClick={handleContent}
                  type="button"
                  className="btn btn-outline-secondary w-100 w-md-auto"
                >
                  <i className="fa fa-info-circle"></i> Temario
                </button>
                {renderButton()}
              </div>
            </div>
          </div>
          {mobilePriceStripe()}
        </div>
      </div>
      {renderModal()}
    </div>
  );
};

export default ProductCard;
